<template>
  <div class="disable-monitoring-container">
    <div class="title">{{ $t('cautionDisableMonitoringLevel') }}</div>
    <div class="content">{{ $t('disableMonitoringInfos') }}</div>
    <div class="choices">
      <div class="cancel main-button" @click.stop="popupResolve(false)">{{ $t('cancel') }}</div>
      <div class="submit main-button" @click.stop="popupResolve(true)">{{ $t('Disable') }}</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['popupResolve', 'popupReject']),
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
@use '@/styles/fonts.scss';
* {
  box-sizing: border-box;
}

.disable-monitoring-container {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
  max-width: 380px;

  .title {
    color: colors.$darkblue-color;
    font-size: 22px;
    font-weight: 500;
    margin-bottom: 10px;
  }

  .content {
    color: colors.$darkgrey-color;
    font-size: 14px;
    opacity: 0.8;
  }

  .choices {
    margin-top: 40px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .main-button {
      margin: 0 12px 0;
      min-width: 135px;
      width: 135px;
      height: 40px;
      padding: 0;
      font-weight: 400;
    }

    .cancel {
      margin: 0 12px 0 0;
      background: colors.$lightgrey-color;
      color: colors.$darkgrey-color;
    }
  }
}
</style>
